export default __webpack_public_path__ + "static/media/falcon5.63222458.png";